import { render, staticRenderFns } from "./VersionRecord.vue?vue&type=template&id=7b930ae2&scoped=true"
import script from "./VersionRecord.vue?vue&type=script&lang=js"
export * from "./VersionRecord.vue?vue&type=script&lang=js"
import style0 from "./VersionRecord.vue?vue&type=style&index=0&id=7b930ae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b930ae2",
  null
  
)

export default component.exports